// extracted by extract-css-chunks-webpack-plugin
module.exports = {"nav":"nav-3CvFb1ao","bgnone":"bgnone-2p8gRd_8","ssr_nav":"ssr_nav-3gltGA90"};